import { Grid, Box } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { ArrowBackIcon } from "./icon";

export const ReportTabT = ({ filterBy }) => {
  const analaticsChuild = useSelector((state) => state.reducer.analaticsChuild);

  const navigate = useNavigate();

  useEffect(() => {
    console.log("analaticsChuild", analaticsChuild);
  }, [filterBy]);

  return (
    <Box sx={{ background: "#ede9ff", height: "100vh" }}>
      <Grid item px={5} py={3}> 
        <ArrowBackIcon
          sx={{ cursor: "pointer" }}
          onClick={() => navigate("/home")}
        />
      </Grid>
      <Grid
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        item
        sm={12}
        container
        spacing={2}
        paddingTop={{ xs: 2, sm: 1 }}
        pl={{ xs: 3, sm: 0 }}
      >
        {analaticsChuild[filterBy]?.map((item, index) => (
          <Grid item xs={12} sm={5} key={index} px={{ md: 8, sm: 3, xs: 2 }}>
            <Box
              sx={{
                height: 50,
                backgroundColor: "#01008B",
                borderRadius: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: 1,
                fontSize: { xs: "12px", sm: "12px", md: "15px" },
                fontWeight: 600,
                color: "#fff",
                cursor: "pointer",
                fontFamily: "'Montserrat', sans-serif",
              }}
              onClick={() => {
                console.log("item routePath", item);
                if (item.routePath) {
                  navigate(item.routePath);
                }
              }}
            >
              {item.label}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
